module.exports = __webpack_public_path__ + "img/矩形 2624.395b754f.png";